import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import vendors from './modules/vendors';
import order from './modules/order';
import fileExtra from './modules/fileExtra';
import d2admin from './modules/d2admin';
import calculateBudge from '@/store/modules/budget';
import calculateQuantity from '@/store/modules/orderQuantity';
import request from '@/util/request';
import util from "@/libs/util";

Vue.config.devtools = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);
// root state object.
// each Vuex instance is just a single state tree.
const state1 = {
    local: 'zh',
    // user: {},
    common: {},
    search_info: {},
    orderBrowsingHistories: [],
    orderIdsToBeApproved: [],
    orders: [],
    userJurisdiction: [],
    businessNotification: [],
    budgetStatus: '',
    clearTimer: false,
    budgetReviewerId: '',
    searchInfoGroup: {}, //
    invoiceDetail: {},
};
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    setSearchInfo(state: any, {key, value}) {
        state.searchInfoGroup[key] = value;
    },
    clearAllSearchInfo(state: any){
      state.searchInfoGroup={};
      console.log("清理掉了搜索缓存");
    },
    changePhone(state: any, phone: string) {
        state.user.phone = phone.replace(phone.substring(3, 8), '****');
    },
    changeMail(state: any, mail: string) {
        const mailArray = mail.split('@');
        state.user.mail = mail.replace(mailArray[0].substring(mailArray[0].length / 2), '***');
    },
    changeUserState(state: any, userState: any) {
        state.user.state = userState;
    },
    changeUserClassLine(state: any, val: any) {
        state.user.serviceIncrementClassLine = val;
    },
    changeUserInfo(state: any, {name, val}: { name: string, val: any }) {
        state.user[name] = val;
    },
    changeAccount(state: any, val: any) {
        state.user.accountCount = val;
    },
    changeUsedCount(state: any, val: any) {
        state.user.usedCount = val;
    },
    budgetStatus(state: any, val: any) {
        state.budgetStatus = val;
    },
    clearTimer(state: any, val: any) {
        state.clearTimer = val;
    },
    invoiceDetail(state: any, val: any) {
        state.invoiceDetail = val;
    },
    changeUserCreditReport(state: any, val: any) {
        state.user.serviceIncrementCreditReport = val;
    },
    getCommon(state: any, res: { common: string, local: string, user: any, status: any }) {
        if (res.status) {
            state.common = res.common;
            state.local = res.local;
            state.user = res.user;
        }
    },
    changeSearch(state: any, info: any) {
        state.search_info[info.name] = info.info;
    },
    budgetReviewerId(state: any, val: number) {
        state.budgetReviewerId = val;
    },
    setOrderBrowsingHistories(state: any, val: any) {
        state.orderBrowsingHistories = val;
    },
    orderIdsToBeApproved(state: any, val: any) {
        state.orderIdsToBeApproved = val;
    },
    setOrders(state: any, val: any) {
        state.orders = val;
    },
    setUser(state: any, val: any) {
        state.userJurisdiction = val.data.user.accessibleOrderIds;
    },
    setBusinessNotification(state: any, val: any) {
        state.businessNotification = val.data.notifications;
    },
    delNotification(state: any, val: any) {
        state.businessNotification.splice(val, 1);
    },
    delAllNotification(state: any, val: any) {
        state.businessNotification = [];
    },
    pageUiSet(state:any, {key,value}){
      let currentValString = util.cookies.get('page_ui_set');
      if(currentValString&&currentValString!=undefined){
        // do noting
      }else{
        currentValString='{}';
      }
      const currentVal = JSON.parse(currentValString);
      currentVal[key]=value;
      const setVal = JSON.stringify(currentVal);
      util.cookies.set('page_ui_op', setVal);
    },
    clearPageUiOp(){
      util.cookies.remove('page_ui_op');
    }
};
const actions = {
    // @ts-ignore
    commonAsync({commit}) {
        // @ts-ignore
        return Vue.http.get('/getCommon').then((res) => {
            res = res.body;
            commit('getCommon', res);
        });
    },
    saveCurrentOrderQuantity({getters}, param) {

        const body: any = {list: getters.orderQuantity};
        if (param && param.force) {
            body.force = true;
            return request.put('/api/order_census_stuff_quantity', body);
        } else {
            request.put('/api/order_census_stuff_quantity', body).then(res => {
            });
        }

    },

};

function pageUiOp(key){
  const currentValString = util.cookies.get('page_ui_op');
  if(currentValString&&currentValString!=undefined){
    return JSON.parse(currentValString);
  }else{
    return {};
  }
}
// getters are functions
const getters = {
    orderBudget: calculateBudge,
    orderQuantity: calculateQuantity,
    pageUiOp:pageUiOp,
    // evenOrOdd: state => state.count % 2 === 0 ? 'even' : 'odd'
};

export interface StoreModel {
    user: any;
}

// A Vuex instance is created by combining the state: any, mutations, actions,
// and getters.
export default new Vuex.Store({
    state() {
        return state1;
    },
    getters,
    actions,
    mutations,
    modules: {
        // user,
        order,
        fileExtra,
        vendors,
        d2admin,
    },

});
